// Angular
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { MenuAsideService } from './menu-aside.service';
@Injectable()
export class MenuConfigService {
  onConfigUpdated$: Subject<any>;

  private menuConfig: any;

  constructor(
    private translate: TranslateService,
    private menuAsideService: MenuAsideService
  ) {
    this.onConfigUpdated$ = new Subject();
  }

  getMenus() {
    return this.menuConfig;
  }

  loadConfigs(config: any) {
    this.menuConfig = config;
    this.onConfigUpdated$.next(this.menuConfig);
    this.menuAsideService.loadMenu(this.menuConfig);
  }

  translateName(translate_name) {
    return this.translate.instant(translate_name);
  }
}
